<template>
 <div class="ui centered grid">
    <div class="four wide column"></div>
    <div class="eight wide column">
      <TheNoteList v-bind:all_notes_view="true" primary_item=""></TheNoteList>
    </div>
    <div class="four wide column"></div>
</div>

</template>

<script>
  import TheNoteList from '../components/TheNoteList_v2.vue'
  export default {
    name: 'list',
    components: {
      TheNoteList,
    },
    data() {
      return {
        
      }
    },


    methods: {
    },

    mounted() {
     // this.loadData(true);

    },

    watch: {
      $route(to, from) {
     //   this.loadData();
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/notes.vue